/*
  Multi-Function Intersection Observer Handlers

  Supports:

    - Direct observation or parent → children cascading activation
    - Optional child selector via data-observe=".child"
    - Custom delay via data-delayfactor / data-index
    - Optional re-trigger via data-toggle="true"
    - Custom threshold per element (data-threshold)

  Examples:

    1. Observe element directly

    <div data-observe data-delayfactor="150">
      I will activate when visible.
    </div>

    2. Parent triggers child animations

    <section data-observe=".card" data-delayfactor="100">
      <div class="card">Item 1</div>
      <div class="card">Item 2</div>
      <div class="card">Item 3</div>
    </section>

    3. Allow re-triggering

    <div data-observe data-toggle="true" data-threshold="0.25">
      Toggle me when entering/leaving viewport.
    </div>
*/

document.addEventListener('DOMContentLoaded', function () {
  const elements = document.querySelectorAll('[data-observe], mark');

  const observerCallback = function (entries, observer) {
    entries.forEach(entry => {
      const target = entry.target;

      const delayFactor = parseInt(target.dataset.delayfactor) || 100;
      const threshold = parseFloat(target.dataset.threshold) || 0.5;
      const toggle = target.dataset.toggle === 'true';
      const childSelector = target.dataset.observe?.trim(); // optional selector (e.g. ".child")

      // PARENT container triggers its children
      if (childSelector && entry.isIntersecting) {
        const children = target.querySelectorAll(childSelector);
        children.forEach((child, index) => {
          const delay = index * delayFactor;
          setTimeout(() => {
            child.dataset.state = 'active';
          }, delay);
        });

        // Stop observing parent once triggered (optional)
        observer.unobserve(target);
        return;
      }

      // Directly observed element
      const index = parseInt(target.dataset.index) || 0;
      const delay = index * delayFactor;

      if (entry.isIntersecting) {
        setTimeout(() => {
          target.dataset.state = 'active';
        }, delay);
      } else if (toggle) {
        target.dataset.state = 'idle';
      }
    });
  };

  // Observe each element with its own threshold
  elements.forEach(element => {
    const dataThreshold = parseFloat(element.dataset.threshold);
    const threshold = isFinite(dataThreshold) ? dataThreshold : 0;
    const rootMargin = element.dataset.rootmargin || '0px 0px 0px 0px';

    const observerOptions = {
      root: null,
      rootMargin,
      threshold,
    };

    const observer = new IntersectionObserver(observerCallback, observerOptions);
    observer.observe(element);
  });
});
